import { Link } from 'react-router-dom'
import type { RosDashboardFilters, RosTypeSplitSide } from './types'
import { useCanOpenQueue } from '../../procurement/queueAccess'
import { queueLink } from './useRosDashboard'

// Текучка vs Проекты: два блока с прогрессом квотирования, кликабельны →
// очередь по типу заявки. У ADMIN очередь закрыта (18.09) — блоки без ссылки
// (решение Сергея 25.09).

function Side({
  title,
  side,
  to,
  barColor,
}: {
  title: string
  side: RosTypeSplitSide
  to?: string
  barColor: string
}) {
  const body = (
    <>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-900">{title}</span>
        <span className="text-xs text-gray-500">
          {side.items.toLocaleString('ru-RU')} поз. · {side.requests.toLocaleString('ru-RU')} заяв.
        </span>
      </div>
      <div className="mt-2">
        <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
          <span>прогресс квотирования</span>
          <span className="font-semibold text-gray-900">{side.progressPct}%</span>
        </div>
        <div className="h-2 bg-gray-200 rounded overflow-hidden">
          <div
            className="h-full rounded transition-all"
            style={{ width: `${Math.max(2, side.progressPct)}%`, backgroundColor: barColor }}
          />
        </div>
      </div>
    </>
  )
  const cls = 'flex-1 rounded-xl border border-gray-200 bg-gray-50 p-3'
  if (!to) return <div className={cls}>{body}</div>
  return (
    <Link to={to} className={`${cls} hover:-translate-y-0.5 transition-transform`}>
      {body}
    </Link>
  )
}

export function RosTypeSplit({
  tekuchka,
  project,
  filters,
}: {
  tekuchka: RosTypeSplitSide
  project: RosTypeSplitSide
  filters: RosDashboardFilters
}) {
  const canQueue = useCanOpenQueue()
  const toType = (requestType: 'TEKUCHKA' | 'PROJECT') =>
    canQueue ? queueLink({ requestType }, { ...filters, type: '' }) : undefined
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="text-sm text-gray-500 mb-3">Текучка vs Проекты</div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Side title="Текучка" side={tekuchka} to={toType('TEKUCHKA')} barColor="#3b82f6" />
        <Side title="Проекты" side={project} to={toType('PROJECT')} barColor="#8b5cf6" />
      </div>
    </div>
  )
}
